var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{attrs:{"width":"193px","src":"/Content/img/talland_Logo.jpg"}})}
var staticRenderFns = []

export { render, staticRenderFns }